import React, { Fragment, Component } from "react";
import "./ThumbsComponent.css";

class Thumbs extends Component {
  state = {
    up: document.getElementsByClassName("up"),
    down: document.getElementsByClassName("down"),
  };

  constructor(props) {
    super(props);
  }

  handleThumbsUp = () => {
    this.props.sendThumbsUpMessage();

    for (let i = 0; i < this.state.up.length; i++) {
      for (let j = 0; j < this.state.down.length; j++) {
        if (i + 1 === this.state.up.length) {
          this.state.up[i].classList.add("active");
          this.state.down[i].classList.remove("active");
        }
      }
    }
  };

  handleThumbsDown = () => {
    this.props.sendMessage("👎");

    for (let i = 0; i < this.state.up.length; i++) {
      for (let j = 0; j < this.state.down.length; j++) {
        if (i + 1 === this.state.up.length) {
          this.state.down[i].classList.add("active");
          this.state.up[i].classList.remove("active");
        }
      }
    }
  };

  render() {
    return (
      <Fragment>
        <div className="thumbs">
          <button onClick={this.handleThumbsUp} className="up"></button>
          <button onClick={this.handleThumbsDown} className="down"></button>
        </div>
      </Fragment>
    );
  }
}

export default Thumbs;
